import React from 'react';
import Icons from '../../../../../../components/Common/Icons/Icons';

interface ITag {
  label: string;
  value: string | number;
}

function Tag({ label, value }: ITag) {
  return (
    <div className="bg-addition6-3 flex items-center gap-[5px] p-[5px] rounded-lg text-[10px] font-medium border">
      <div className="opacity-60">{`${label}:`}</div>
      <div>{value}</div>
      <Icons.PlusFilled className="opacity-40 w-[12px] h-[12px] rotate-45 cursor-pointer" />
    </div>
  );
}

export default Tag;
